import { Component } from '@angular/core';
import { Direction } from '@angular/cdk/bidi';
import { filter } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService, isUserDemoProfile } from '@nano/core/auth';
import { L10nService } from '@nano/core/l10n';

@UntilDestroy()
@Component({
  selector: 'app-user',
  templateUrl: 'user.component.html',
  styleUrls: ['user.component.less'],
  standalone: false
})
export class UserComponent {
  userTitle: string;
  userFullName: string;
  userTitleVisible = false;
  dropdownVisible = false;
  direction: Direction;

  constructor(
    private authService: AuthService,
    private l10nService: L10nService
  ) {
    this.authService.userProfile$
      .pipe(
        untilDestroyed(this),
        filter((userProfile) => !!userProfile)
      )
      .subscribe((userProfile) => {
        this.userTitleVisible = !isUserDemoProfile(userProfile);
        this.userTitle = userProfile.privatePerson ? userProfile.personGivenName : userProfile.fullName;
        this.userFullName = userProfile.fullName;
      });

    this.l10nService.schema$
      .pipe(
        untilDestroyed(this),
        filter((schema) => !!schema)
      )
      .subscribe((schema) => (this.direction = schema.dir));
  }

  dropdownVisibleChange(dropdownVisible: boolean): void {
    this.dropdownVisible = dropdownVisible;
  }

  dropdownItemClicked(): void {
    this.dropdownVisible = false;
  }
}
